import {getThemeColor} from '@esgi/ui';

export const DIAGRAM_HEIGHT = 300;
export const MIN_DIAGRAM_SESSIONS_COUNT = 10;

export const PRIMARY_COLOR = getThemeColor('primary64');
export const SECONDARY_COLOR = getThemeColor('neutral64');
export const BASELINE_COLOR = getThemeColor('secondary56');
export const WHITE_COLOR = getThemeColor('neutral99');